import vars from '../helpers';

function introAnimation(container) {
	const drawSVG = $(container).find('.home__lineSVG');
	const introPoster = $(container).find('.home__image-transform');

	gsap.timeline()
		.from($(container).find('.home__title--1 .js-animation'), {
			clearProps: 'all',
			yPercent: '-105',
			duration: 0.6
		}, 0.8)
		.from($(container).find('.home__title--2 .js-animation'), {
			clearProps: 'all',
			yPercent: '-105',
			duration: 0.6,
			onComplete: () => {
				introPoster.addClass('is-play');
			}
		}, 0.8)
		.from($(container).find('.home__desc'), {
			clearProps: 'all',
			yPercent: '-20',
			duration: 0.6,
			autoAlpha: 0,
			onStart: () => {
				drawSVG.addClass('is-play');
			}
		}, 2)
		.from($(container).find('.card-home'), {
			clearProps: 'all',
			yPercent: -120,
			stagger: 0.2,
			duration: 0.9,
			autoAlpha: 0,
			onComplete: function (el) {
				$(container).find('.home-cards__wrapper').addClass('is-clickable');
			}
		}, 3);
}

function togglePopup(container) {
	$(container).find('.js-open').on('click',function(){
		let currentEl = this.closest('.home-cards__item');
		$(currentEl).toggleClass('is-open');
		console.log($(currentEl));
	});
}

function init(container) {
	introAnimation(container);
	togglePopup(container);
}

function destroy(container) {
	$(container).find('.js-open').off('click');
}

export default {
	init,
	destroy,
};
